import React, { useState, useEffect } from 'react';
import firebase from 'firebase';

import FilterRole from '../components/FilterRole';

function Users() {
  const [isLoading, setLoadingStatus] = useState(true);
  const [allUsers, setAllUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  const [selectedRole, setRole] = useState('');

  useEffect(() => {
    (async function() {      
      // pull users from firebase
      await firebase.database().ref('users').on('value', (snapshot) => {
        let usersFromFirebase = [];

        const usersList = snapshot.toJSON();
        const usersIds = Object.keys(usersList);
  
        usersIds.forEach((id) => {
          usersFromFirebase.push({
            userId: id,
            ...usersList[id],
          });
        });
  
        setLoadingStatus(false);
        setAllUsers(usersFromFirebase);
        setFilteredUsers(usersFromFirebase);
      });
    }());
  }, []);

  useEffect(() => {
    let filteredUsers = [];
    // filter users by status
    filteredUsers = allUsers.filter(user => selectedRole === '' || selectedRole === user.role);

    setLoadingStatus(false);
    setFilteredUsers(filteredUsers);
  }, [allUsers, selectedRole]);

  const changeUserRole = async (e, userId) => {
    await firebase.database().ref(`users/${userId}`).update({
      role: e.target.value,
    });
  }


  const renderUsers = () => {
    if (isLoading) return <React.Fragment />;

    return (
      <table className="table">
        <thead>
          <tr>
            <th>User name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Role</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map(({ userId, phone, name, role, email }) => (
            <tr key={userId}>
              <td>{name.firstName} {name.lastName}</td>
              <td>{email}</td>
              <td>{phone}</td>
              <td>
                <select value={role} onChange={(e) => changeUserRole(e, userId)} className="form-control">
                  <option>user</option>
                  <option>admin</option>
                </select>
              </td>

            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <div>
      <h3 className="page-header">Users</h3>
      <div className="row">
        {/* <div className="col-xs-12 col-md-4">
          <FilterDate onChange={event => setSortedBy(event.target.value)} />
        </div> */}
        <div className="col-xs-12 col-md-4">
          <FilterRole onChange={event => setRole(event.target.value)} />
        </div>
      </div>

      {renderUsers()}
    </div>
  );
}

export default Users;
